// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import GeneralCompany from "./GeneralCompany";
import { StyledBreadcrumb, AppHeader } from "imagus-components";
import { addCompanyTab, setCompanyStep } from "../../actions/userActions";
import {
  fetchMyCompanyGraphQl,
  fetchChildCompanyGraphQl
} from "../../actions/companyActions";

class MyCompany extends Component<*> {
  componentDidMount() {
    if (this.props.user.step === null) {
      this.props.actions.fetchMyCompanyGraphQl(this.setFirstTab);
    }
  }

  setFirstTab = () => {
    this.props.actions.addCompanyTab({
      label: this.props.company.name,
      id: this.props.company.id,
      component: <GeneralCompany />
    });
  };

  changeStep = (index: number): * => {
    this.props.actions.fetchChildCompanyGraphQl(
      this.props.user.tabs[index].id,
      (): * => this.props.actions.setCompanyStep(index)
    );
  };

  render(): * {
    let iconName = "StarBorder";
    if (this.props.company.companyType === "TOPLEVEL") {
      iconName = "Stars";
    } else if (this.props.company.companyType === "DISTRIBUTER") {
      iconName = "Star";
    } else if (this.props.company.companyType === "RESELLER") {
      iconName = "StarHalf";
    } else if (this.props.company.companyType === "ENDUSER") {
      iconName = "StarBorder";
    }
    return (
      <Fragment>
        <AppHeader title={this.props.company.name} IconName={iconName} />
        <StyledBreadcrumb
          tabs={this.props.user.tabs}
          step={this.props.user.step}
          onClick={this.changeStep}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user,
  company: state.v3account.company
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      addCompanyTab,
      setCompanyStep,
      fetchMyCompanyGraphQl,
      fetchChildCompanyGraphQl
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyCompany);
